'use client';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { useUsermaven } from '@prismo-io/tracking';
import { type FC, type PropsWithChildren, useCallback, useState } from 'react';
export const CustomModal: FC<PropsWithChildren> = ({
  children
}) => {
  const usermaven = useUsermaven();
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => {
    setOpen(true);
    usermaven.track('tsid-open-google-form');
  }, [usermaven]);
  const handleClose = () => setOpen(false);
  return <Box component="div" sx={{
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center'
  }} data-sentry-element="Box" data-sentry-component="CustomModal" data-sentry-source-file="index.tsx">
      <Button onClick={handleOpen} sx={{
      borderRadius: '100%',
      width: '7rem',
      height: '7rem'
    }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        <AddIcon fontSize="large" data-sentry-element="AddIcon" data-sentry-source-file="index.tsx" />
      </Button>

      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" data-sentry-element="Modal" data-sentry-source-file="index.tsx">
        <Fade in={open} data-sentry-element="Fade" data-sentry-source-file="index.tsx">
          <Box sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'fit-content',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: '4px'
        }} component="article" position="absolute" data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Box component="div" position="relative" data-sentry-element="Box" data-sentry-source-file="index.tsx">
              <Box component="div" position="absolute" top={4} right={4} zIndex={10} data-sentry-element="Box" data-sentry-source-file="index.tsx">
                <IconButton onClick={handleClose} data-sentry-element="IconButton" data-sentry-source-file="index.tsx">
                  <CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="index.tsx" />
                </IconButton>
              </Box>
              {children}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>;
};